import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, Phone, MapPin } from "lucide-react";
import { SOCIAL_LINKS, SUPPORT_EMAIL, WHATSAPP_NUMBER, FOUNDER_URL } from "../../constants/data";

export default function Footer() {
  return (
    <footer className="bg-[#2D2424] text-[#FFFAF3] pt-16 pb-8 relative overflow-hidden" data-testid="footer">
      <svg className="absolute top-0 left-0 right-0 w-full h-6" viewBox="0 0 1200 24" preserveAspectRatio="none">
        <path d="M0 24 Q 50 0 100 12 T 200 12 T 300 12 T 400 12 T 500 12 T 600 12 T 700 12 T 800 12 T 900 12 T 1000 12 T 1100 12 T 1200 12 L 1200 0 L 0 0 Z" fill="#FFFAF3"/>
      </svg>
      <div className="container-x grid grid-cols-1 md:grid-cols-3 gap-12 relative">
        <div>
          <h3 className="font-doodle text-4xl text-[#FFFAF3]">Naathi Charami</h3>
          <p className="text-xs tracking-[0.3em] uppercase text-[#F2E8E4]/60 mt-1">Gifts &amp; Hampers</p>
          <div className="flex items-center gap-3 mt-5 opacity-0 hidden">
            <img src={FOUNDER_URL} alt="" />
            <div>
              <p className="font-serif text-sm text-[#F2E8E4]">Monalika Reddy</p>
              <p className="text-[10px] tracking-[0.2em] uppercase text-[#F2E8E4]/60">Founder</p>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-[#F2E8E4]/75">
            "I shall never leave your side" — a promise of love, care &amp; togetherness through thoughtful gifting.
          </p>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.25em] uppercase text-[#F2E8E4]/60 mb-5">Policies</h4>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-privacy" to="/policy/privacy" className="hover:text-[#F2E8E4]">Privacy Policy</Link></li>
            <li><Link data-testid="footer-link-shipping" to="/policy/shipping" className="hover:text-[#F2E8E4]">Shipping Policy</Link></li>
            <li><Link data-testid="footer-link-return" to="/policy/return" className="hover:text-[#F2E8E4]">Return &amp; Refund</Link></li>
            <li><Link data-testid="footer-link-terms" to="/policy/terms" className="hover:text-[#F2E8E4]">Terms &amp; Conditions</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.25em] uppercase text-[#F2E8E4]/60 mb-5">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0" strokeWidth={1.5}/><span>+91 93460 42323</span></li>
            <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 shrink-0" strokeWidth={1.5}/><a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-[#F2E8E4]">{SUPPORT_EMAIL}</a></li>
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0" strokeWidth={1.5}/><span>Hyderabad, India<br/><span className="text-[#F2E8E4]/60 text-xs">Support: 10 AM – 7 PM</span></span></li>
          </ul>
          <div className="flex items-center gap-4 mt-6">
            <a data-testid="social-instagram" href={SOCIAL_LINKS.instagram} target="_blank" rel="noreferrer" className="hover:text-[#F2E8E4]/70"><Instagram className="w-5 h-5" strokeWidth={1.5}/></a>
            <a data-testid="social-facebook" href={SOCIAL_LINKS.facebook} target="_blank" rel="noreferrer" className="hover:text-[#F2E8E4]/70"><Facebook className="w-5 h-5" strokeWidth={1.5}/></a>
            <a data-testid="social-youtube" href={SOCIAL_LINKS.youtube} target="_blank" rel="noreferrer" className="hover:text-[#F2E8E4]/70"><Youtube className="w-5 h-5" strokeWidth={1.5}/></a>
          </div>
        </div>
      </div>

      <div className="container-x mt-12 pt-6 border-t border-[#F2E8E4]/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-[#F2E8E4]/50">
        <p>© {new Date().getFullYear()} Naathi Charami Gifts &amp; Hampers. Founded by Monalika Reddy.</p>
        <p>Crafted with care in Hyderabad.</p>
      </div>
    </footer>
  );
}
